import { Api } from '../helpers';

const agentActionsModel = {
  getUsersZPLDetails(params, url) {
    const path = url;
    return Api.get({ path, queryParams: params });
  },

  getKebabItems(data) {
    const body = data.body;
    const params = data.params;
    const path = 'order/get_kebabs';
    return Api.get({ path, queryParams: params });
  },

  getBMoneyDetails(params) {
    const path = 'user/get_bmoney_history';
    return Api.get({ path, queryParams: params });
  },

  getUserPromoDetail(params) {
    const path = 'order/get_user_promo';
    return Api.get({ path, queryParams: params });
  },

  getReasons(params) {
    const path = 'order/get_escalation_info';
    return Api.get({ path, queryParams: params });
  },

  getEmailEscalations(params) {
    const path = 'user/get_email_escalations';
    return Api.get({ path, queryParams: params });
  },

  changeTicketPriority(data) {
    const body = data;
    const path = 'user/change_ticket_priority';
    return Api.post({ path }, { body });
  },

  sendEsclate(data) {
    const body = data;
    const path = 'order/escalate';
    return Api.post({ path }, { body });
  },

  sendNotificationToValet(data) {
    const body = data;
    const path = 'logistics/notify_valet';
    return Api.post({ path }, { body });
  },

  addSpecialInstructions(data, isMxInstruction) {
    const body = data;
    let path = '';
    if (isMxInstruction) {
      path = 'mx_instructions/update_mx_instructions';
    } else {
      path = 'order/add_special_instruction';
    }
    return Api.post({ path }, { body });
  },

  UpdateAgentPermissions(data, hostName, headers) {
    const body = data;
    const path = 'api/v1/agents/agent-permission';
    return Api.post({ path }, { body }, headers, true, hostName);
  },

  getGiftCardDetails(params) {
    const path = 'order/get_giftcard_history';
    return Api.get({ path, queryParams: params });
  },

  getUserNumberDetails(params) {
    const path = 'number_verification/user_number_details';
    return Api.get({ path, queryParams: params });
  },

  unlinkUserNumber(params) {
    const path = `number_verification/unlink_user_number`;
    return Api.post({ path }, { body: params });
  },

  getPromoCodeDetails(params) {
    const path = `promo/get_promo_details`;
    return Api.get({ path, queryParams: params });
  },

  getPromoFilesDownloaded(params) {
    const path = `promo/download_csv`;
    return Api.get({ path, queryParams: params });
  },
};

export default agentActionsModel;
